import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { headerStyles as styles } from '@/header/header.styles';
import { runReportCopyForEmail } from '@/header/lockedTopicActions.utilities';
import { setShowModal } from '@/reportEditor/pdfExport.actions';
import { fcCopy, fcPdfExport } from '@seeqdev/icons/seeq';
import { Icon } from '@seeqdev/qomponents';

export const LockedTopicActions = () => {
  const { t } = useTranslation();

  return (
    <div {...stylex.props(styles.lockedTopicActions)} data-testid="locking-actions">
      <Icon
        icon={fcPdfExport}
        tooltip={t('REPORT.EDITOR.SAVE_AS_PDF_BUTTON_TITLE')}
        tooltipPlacement="bottom"
        type="theme-light"
        large={true}
        onClick={() => setShowModal(true)}
        testId="pdfExportIcon"
        xstyle={styles.themedNavbarAction}
      />
      <Icon
        icon={fcCopy}
        tooltip={t('REPORT.EDITOR.COPY_FOR_EMAIL')}
        tooltipPlacement="bottom"
        type="theme-light"
        large={true}
        onClick={runReportCopyForEmail}
        testId="copyForEmailIcon"
        xstyle={styles.themedNavbarAction}
      />
    </div>
  );
};
